<app-result-shell
  [loading]="loading"
  [error]="error"
  [stats]="snapshotData"
  (back)="goBack()"
>
  <div shell-header>
    <div class="h1">{{ "results.snapshot.title" | translate }}</div>
    <p class="p">
      {{ "results.snapshot.description" | translate }}
    </p>
  </div>

  <ng-container *ngIf="snapshotData">
    <div
      [ngClass]="i === 0 ? 'summary-section' : 'card'"
      *ngFor="let metric of snapshotData.metrics; let i = index"
    >
      <div class="summary-label" *ngIf="i === 0">
        {{ "results.snapshot.summary" | translate }}
      </div>
      <div
        class="summary-content"
        [ngClass]="{ 'blurred-content': isBlurredSection(i) }"
      >
        <div class="summary-content-wrapper">
          <app-circular-meter [value]="metric.value"></app-circular-meter>
          <div class="summary-content-wrapper-inner">
            <div class="summary-header">
              <h2 class="summary-title">{{ metric.titleKey | translate }}</h2>
              <span
                class="severity-badge"
                [ngClass]="getSeverityLevel(metric.value, i).class"
              >
                {{ getSeverityLevel(metric.value, i).label }}
              </span>
            </div>
            <p class="summary-description">{{ metric.descriptionKey | translate }}</p>
            <div class="read-more-section" (click)="toggleFullExplanation(i)">
              <span class="read-more-text">{{
                "results.snapshot.readFullExplanation" | translate
              }}</span>
              <span class="read-more-link">{{
                "results.snapshot.readMore" | translate
              }}</span>
            </div>
            <div class="full-explanation" *ngIf="showFullExplanationMap[i]">
              <p>{{ getFullExplanationText(i) }}</p>
            </div>

            <div *ngIf="snapshotData.checkCount > 1" class="tags-container">
              <span class="tag"
                >{{ "results.stats.vsLast" | translate }}
                {{ metric.vsLast >= 0 ? "+" : "" }}{{ metric.vsLast }}</span
              >
              <span class="tag"
                >{{ "results.stats.vsBaseline" | translate }}
                {{ metric.vsBaseline >= 0 ? "+" : ""
                }}{{ metric.vsBaseline }}</span
              >
            </div>
          </div>
        </div>

        <div *ngIf="snapshotData.checkCount > 1" class="spark">
          <div class="spark-header">
            <div class="sparktitle">
              {{
                "results.snapshot.trend"
                  | translate : { count: metric.scanHistory.length }
              }}
            </div>
            <div class="alignment-text">
              {{ getAlignmentText(i) }}
            </div>
          </div>
          <div class="sparkline">
            <app-sparkline
              [data]="metric.scanHistory"
              [labels]="metric.scanDates"
            ></app-sparkline>
          </div>
        </div>
      </div>

      <div *ngIf="isBlurredSection(i)" class="unlock-section">
        <div class="trial-banner">
          <div class="banner-content">
            <p class="banner-text">
              {{ "results.snapshot.trialBanner.previewMessage" | translate }}
            </p>
            <div class="banner-actions">
              <button
                class="banner-unlock-button"
                (click)="navigateToPayment()"
              >
                {{
                  "results.snapshot.trialBanner.unlockButton"
                    | translate : { price: currencySymbol + singleScanPrice }
                }}
              </button>
              <a class="view-plans-link" (click)="navigateToPayment()">
                {{ "results.snapshot.trialBanner.viewPlansLink" | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</app-result-shell>
